import styled from "styled-components";
import { rem } from "convert-to-ems";

export const CardBoxElement = styled.div.withConfig({ displayName: "GenericCardBox" })`
  display: ${props => props.display};
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  background-color: ${props => props.theme.baseColor};
  border-radius: ${rem(8)};
  box-shadow: ${props => (props.boxShadow ? `${rem(0)} ${rem(1)} ${rem(2)} #00000029` : null)};
  box-shadow: ${props =>
    props.boxShadowHard ? `${rem(0)} ${rem(1)} ${rem(2)} ${rem(1.4)} #00000029` : null};
  min-width: ${props => (props.minWidth ? rem(props.minWidth) : "")};
  max-width: ${props => (props.maxWidth ? rem(props.maxWidth) : "")};
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
  margin-top: ${props => rem(props.marginTop)};
  margin-bottom: ${props => rem(props.marginBottom)};

  color: #000;
  opacity: 1;
  padding-top: ${props => rem(props.paddingTop)};
  padding-left: ${props => rem(props.paddingLeft)};
  padding-right: ${props => rem(props.paddingRight)};
  padding-bottom: ${props => rem(props.paddingBottom)};
`;
